import { AssetsSubCatagoryDto } from "@gtpl/shared-models/asset-management";
import { AssetsCatagory } from "../../assets-catagory/assets-catagory-entity";
import { AssetsSubCatagory } from "../assets-sub-catagory-entity";
import { AssetsSubCatagoryDTO } from "./assets-sub-catagory-dto";





export class AssetsSubCatagoryAdapter {
    convertDtoToEntity(dtoObj: AssetsSubCatagoryDTO, isUpdate: boolean = false): AssetsSubCatagory {
        try {
            const entityObj = new AssetsSubCatagory();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.assetsSubCatagoryName = dtoObj.assetsSubCatagoryName;
            entityObj.assetsCatagoryInfo = new AssetsCatagory();
            entityObj.assetsCatagoryInfo.assetsClassificationId = dtoObj.assetsCatagoryId;
            if (dtoObj.assetsSubCatagoryId) {
                entityObj.assetsSubCatagoryId = dtoObj.assetsSubCatagoryId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(assetsObject: AssetsSubCatagory): AssetsSubCatagoryDTO {
        const assetsDTO = new AssetsSubCatagoryDTO;
        assetsDTO.assetsSubCatagoryId = assetsObject.assetsSubCatagoryId;
        assetsDTO.assetsCatagoryId = assetsObject.assetsCatagoryInfo.assetsCatagoryId;
        assetsDTO.assetsCatagoryName = assetsObject.assetsCatagoryInfo.assetsCatagoryName;
        assetsDTO.assetsSubCatagoryName = assetsObject.assetsSubCatagoryName;
        assetsDTO.isActive = assetsObject.isActive;
        assetsDTO.createdUser = assetsObject.createdUser;
        assetsDTO.updatedUser = assetsObject.updatedUser;
        return assetsDTO;
    }
    public convertEntityDetails(assetsObject: AssetsSubCatagory): AssetsSubCatagoryDto {
        const assetsDetails = new AssetsSubCatagoryDto(assetsObject.assetsCatagoryId, assetsObject.assetsCatagoryInfo.assetsCatagoryName, assetsObject.assetsSubCatagoryName, assetsObject.createdUser, assetsObject.updatedUser, assetsObject.isActive, assetsObject.versionFlag);
        return assetsDetails;
    }

}
